<div class="totals-wrapper row">

    <!-- Automatic Box -->
    <mat-card class="totals-card daxa-card border-none bg-white c">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mb-0">{{'Automatic Totals' | translate}}</h5>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <table class="totals-table" *ngIf="automatic?.length">
                <tr>
                    <th>{{'Serial number' | translate}}</th>
                    <td>{{ automatic[0].serialNumber }}</td>
                </tr>
                <tr>
                    <th>{{'Total Charged' | translate}}</th>
                    <td>{{ automatic[0].totalChargedKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Total Discharged' | translate}}</th>
                    <td>{{ automatic[0].totalDischargedKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Solar Production' | translate}}</th>
                    <td>{{ automatic[0].totalSolarProductionKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Total Consumption' | translate}}</th>
                    <td>{{ automatic[0].totalConsumptionKwh != null ? (automatic[0].totalConsumptionKwh | number:'1.2-2') + ' kWh' : ('N/A' | translate) }}</td>
                </tr>
                <tr>
                    <th>{{'total_profit' | translate}}</th>
                    <td>{{ automatic[0].totalPrice | number:'1.2-2' }} kr.</td>
                </tr>
            </table>

            <p *ngIf="!automatic?.length">{{'No automatic data.' | translate}}</p>
        </mat-card-content>
    </mat-card>

    <!-- Manual Box -->
    <mat-card class="totals-card daxa-card border-none bg-white">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mb-0">{{'Manual Totals' | translate}}</h5>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <table class="totals-table" *ngIf="manual?.length">
                <tr>
                    <th>{{'Serial number' | translate}}</th>
                    <td>{{ manual[0].serialNumber }}</td>
                </tr>
                <tr>
                    <th>{{'Total Charged' | translate}}</th>
                    <td>{{ manual[0].totalChargedKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Total Discharged' | translate}}</th>
                    <td>{{ manual[0].totalDischargedKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Solar Production' | translate}}</th>
                    <td>{{ manual[0].totalSolarProductionKwh }} kWh</td>
                </tr>
                <tr>
                    <th>{{'Total Consumption' | translate}}</th>
                    <td>{{ manual[0].totalConsumptionKwh != null ? (manual[0].totalConsumptionKwh | number:'1.2-2') + ' kWh' : ('N/A' | translate) }}</td>
                </tr>
                <tr>
                    <th>{{'total_profit' | translate}}</th>

                    <td>{{ manual[0].totalPrice | number:'1.2-2' }} kr.</td>
                </tr>
            </table>

            <p *ngIf="!manual?.length">{{'No manual data.' | translate}}</p>
        </mat-card-content>

    </mat-card>

</div>